// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { useRef } from 'react';

// project imports
import Customization from 'layout/Customization';
import AppBar from 'ui-component/extended/AppBar';
import HeaderSection from './HeaderSection';
import FeaturesShowcase from './FeaturesShowcase';
import StatsSection from './StatsSection';
import FeatureSection from './FeatureSection';
import FrameworkSection from './FrameworkSection';
import FooterSection from '../../../layout/MainLayout/Footer/FooterSection';

// custom style
const HeaderWrapper = styled('div')(({ theme }) => ({
    overflowX: 'hidden',
    overflowY: 'clip',
    background: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.background.paper
}));

const SectionWrapper = styled('div')({
    paddingTop: 80,
    paddingBottom: 80
});

const SectionWrapperFooter = styled('div')({
    paddingTop: 50,
    paddingBottom: 0
});

// =============================|| LANDING MAIN ||============================= //

const Landing = () => {
    const theme = useTheme();
    const featureSectionRef = useRef(null);
    const frameworkSectionRef = useRef(null);

    const handleExperienceClick = () => {
        featureSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const handleServiceClick = () => {
        frameworkSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            {/* 1. Header and Hero Section */}
            <HeaderWrapper id="home">
                <AppBar onServiceClick={handleServiceClick} />
                <HeaderSection onExperienceClick={handleExperienceClick} />
            </HeaderWrapper>

            {/* 2. Statistics Section */}
            <StatsSection />

            {/* 3. Features Showcase Section */}
            <SectionWrapper ref={featureSectionRef} sx={{ bgcolor: theme.palette.mode === 'dark' ? 'background.default' : 'grey.50' }}>
                <FeaturesShowcase />
            </SectionWrapper>

            {/* 4. Original Feature Section (Experience) */}
            <SectionWrapper sx={{ bgcolor: theme.palette.mode === 'dark' ? 'dark.dark' : 'background.default' }}>
                <FeatureSection />
            </SectionWrapper>

            {/* 5. Services/Framework Section */}
            <SectionWrapper ref={frameworkSectionRef} sx={{ bgcolor: theme.palette.mode === 'dark' ? 'background.default' : 'grey.50' }}>
                <FrameworkSection />
            </SectionWrapper>

            {/* 6. Footer Section */}
            <SectionWrapperFooter
                sx={{
                    bgcolor: theme.palette.mode === 'dark' ? 'dark.dark' : theme.palette.grey[100],
                    pb: 0
                }}
            >
                <FooterSection />
            </SectionWrapperFooter>

            <Customization />
        </>
    );
};

export default Landing;
